import { inject, Injectable, Injector } from '@angular/core';
import { ENVIRONMENT_CONFIG } from '../../app.environment.config';


@Injectable({
	providedIn: 'root',
})
export class ConfigService {
	private environmentConfig = inject(ENVIRONMENT_CONFIG);

	constructor(private injector: Injector) {}

	isActiveEnvironment(): boolean {
		return this.environmentConfig.fetrapiActiveEnvironment;
	}
	isProduction(): boolean {
		return this.environmentConfig.production;
	}

	getEnv(key: string): string | string[] {
		const env = this.environmentConfig[key];
		return env;
	}
}
